var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"position":"relative"},attrs:{"id":"chart-container"}},[_c('HighChart',{ref:"highchart",attrs:{"options":_vm.chartOptions}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"spinner",staticStyle:{"position":"absolute","top":"55%","left":"50%","transform":"translate(-50%, -50%)"}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bad2768","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch/AlarmPreviewScatter.vue
// module id = null
// module chunks = 